import _ from 'lodash';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { clrBenchmark, clrHistoric, clrLive, clrPredicted } from './config';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const jsPDF = require('jspdf');

function generateTableBody(data) {
  const tableHeaders = Object.keys(data[0]).map((header) => ({
    text: header,
    alignment: 'center',
    fontSize: 8,
    fillColor: '#eeeeee',
    bold: true,
    wordBreak: 'break-all',
  }));

  const tableBody = [tableHeaders];

  data.forEach((item) => {
    const rowData = tableHeaders.map((header) => ({
      text: item[header.text] ? item[header.text].toString() : '',
      fontSize: 8,
    }));
    tableBody.push(rowData);
  });
  return tableBody;
}

// export to pdf
export const exportToPDF = (data, columnsObj) => {
  const columns = columnsObj.map((a) => a.name);
  const keys = columnsObj.map((a) => a.key);

  const x = document.createElement('TABLE');
  for (let c = 0; c < data.length; c++) {
    const y = document.createElement('TR');
    x.appendChild(y);
    let obj = data[c];
    keys.forEach((key) => {
      const value = obj[key];
      const aa = document.createElement('TD');
      const bb = document.createTextNode(value);
      aa.appendChild(bb);
      y.appendChild(aa);
    });
  }

  const doc = new jsPDF('l', 'pt', 'a1', true);

  const res = doc.autoTableHtmlToJson(x);
  doc.autoTable(columns, res.data, {
    startY: 60,
    margin: { top: 60 },
    styles: {
      fontSize: 24,
      overflow: 'linebreak',
      columnWidth: 'auto',
      minCellWidth: 'wrap',
    },
    theme: 'grid',
  });
  const d = new Date();
  doc.save(
    `${d.getFullYear()}${
      d.getMonth() + 1
    }${d.getDate()}${d.getHours()}:${d.getMinutes()}_EE_ALERTS.pdf`
  );
};

export const JSONToXLSXConvertor = (data, fileName) => {
  const wb = XLSX.utils.book_new();
  const ws1 = XLSX.utils.json_to_sheet(data[0]);
  const ws2 = XLSX.utils.json_to_sheet(data[1]);

  XLSX.utils.book_append_sheet(wb, ws1, 'Sheet1');
  XLSX.utils.book_append_sheet(wb, ws2, 'Sheet2');

  if (data.length >= 3) {
    const ws3 = XLSX.utils.json_to_sheet(data[2]);
    XLSX.utils.book_append_sheet(wb, ws3, 'Sheet3');
  }
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };
  saveAs(
    new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
    `${fileName}.xlsx`
  );
};
export const JSONToXLSConvertor = (data, fileName) => {
  const wb = XLSX.utils.book_new();

  const ws1 = XLSX.utils.json_to_sheet(data[0]);
  const ws2 = XLSX.utils.json_to_sheet(data[1]);

  XLSX.utils.book_append_sheet(wb, ws1, 'Sheet1');
  XLSX.utils.book_append_sheet(wb, ws2, 'Sheet2');

  if (data.length >= 3) {
    const ws3 = XLSX.utils.json_to_sheet(data[2]);
    XLSX.utils.book_append_sheet(wb, ws3, 'Sheet3');
  }

  const wbout = XLSX.write(wb, { bookType: 'xls', type: 'binary' });
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };
  saveAs(
    new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
    `${fileName}.xls`
  );
};

function generateColumnWidths(data) {
  const keys = Object.keys(data);
  const columnWidth = 100 / keys.length;
  return keys.map(() => `${columnWidth}%`);
}

export const JSONToPDFConvertor = (data, fileName, reportHeader) => {
  let logoImage = '';
  const defautConfig = localStorage.getItem('defaultConfig');
  if (defautConfig && defautConfig !== 'undefined') {
    const config = JSON.parse(defautConfig);
    logoImage = config.logo;
  }
  let headerData = reportHeader.header;
  if (
    reportHeader.frequencyValue !== null &&
    reportHeader.frequencyValue !== ''
  ) {
    headerData =
      headerData + ', Frequency Value: ' + reportHeader.frequencyValue;
  }

  const headerText = JSON.stringify(data[0]);
  const parsedHeader = JSON.parse(headerText);
  let reportTitle = parsedHeader[0][''];

  if (reportTitle === undefined) {
    const keyTextArray = parsedHeader.map((item) => Object.keys(item)[0]);
    reportTitle = keyTextArray[0];
  }
  const pdfDataTableOne = data[1];
  const tableBodyOne = generateTableBody(pdfDataTableOne);

  let pdfDataTableTwo;
  let tableBodyTwo;
  const FONT_SIZE_HEADER = 22;
  const FONT_SIZE_TABLE = 18;
  const PAGE_WIDTH = 1200;
  const PAGE_HEIGHT = 800;
  const PAGE_MARGINS = [20, 40, 20, 40];

  if (data.length >= 3) {
    pdfDataTableTwo = data[2];
    tableBodyTwo = generateTableBody(pdfDataTableTwo);
    const docDefinition = {
      content: [
        {
          image: logoImage,
          style: 'logoStyle',
        },
        {
          text: ' ',
        },
        {
          text: reportTitle,
          style: 'fileName',
        },
        {
          text: ' ',
        },
        {
          text: headerData,
          style: 'header',
        },
        {
          table: {
            headerRows: 1,
            body: tableBodyOne,
            widths: generateColumnWidths(data[1][0]),
          },
          style: 'table1',
        },
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            body: tableBodyTwo,
            widths: generateColumnWidths(data[2][0]),
          },
          style: 'table2',
        },
        {
          text: ' ',
        },
        {
          text: ' ',
        },
        {
          text:
            'In Charge                                                                                                           ' +
            'Reviewed By                                                                        ' +
            '                                   Signature                                     ',
          style: 'footer',
        },
      ],
      styles: {
        logoStyle: {
          alignment: 'right',
        },
        fileName: {
          fontSize: FONT_SIZE_HEADER,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        header: {
          fontSize: FONT_SIZE_HEADER,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        table1: {
          fontSize: FONT_SIZE_TABLE,
          margin: [0, 0, 0, 10],
        },
        table2: {
          fontSize: FONT_SIZE_TABLE,
          margin: [0, 0, 0, 10],
        },
        footer: {
          fontSize: FONT_SIZE_HEADER,
          bold: true,
          margin: [0, 0, 0, 10],
        },
      },
      pageSize: {
        width: PAGE_WIDTH,
        height: PAGE_HEIGHT,
      },
      pageMargins: PAGE_MARGINS,
    };

    const pdfDoc = pdfMake.createPdf(docDefinition);
    pdfDoc.download(fileName);
  } else {
    let docDefinition = {
      content: [
        {
          text: reportTitle,
          style: 'fileName',
        },
        {
          text: ' ',
        },
        {
          text: headerData,
          style: 'header',
        },
        {
          table: {
            headerRows: 1,
            body: tableBodyOne,
            widths: generateColumnWidths(data[1][0]),
          },
          style: 'table1',
        },
        {
          text: ' ',
        },
        {
          text:
            'In Charge                                                                  ' +
            'Reviewed By                                                                  ' +
            '            Signature',
          style: 'footer',
        },
      ],
      styles: {
        logoStyle: {
          alignment: 'right',
        },
        fileName: {
          fontSize: FONT_SIZE_HEADER,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        header: {
          fontSize: FONT_SIZE_HEADER,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        table1: {
          fontSize: FONT_SIZE_TABLE,
          margin: [0, 0, 0, 10],
        },
        footer: {
          fontSize: FONT_SIZE_HEADER,
          bold: true,
          margin: [0, 0, 0, 10],
        },
      },
      pageSize: {
        width: PAGE_WIDTH,
        height: PAGE_HEIGHT,
      },
      pageMargins: PAGE_MARGINS,
    };

    if (logoImage !== '') {
      docDefinition = {
        ...docDefinition,
        content: [
          {
            image: logoImage,
            style: 'logoStyle',
          },
          {
            text: ' ',
          },
          ...docDefinition.content,
        ],
      };
    }
    const pdfDoc = pdfMake.createPdf(docDefinition);
    pdfDoc.download(fileName);
  }
};

export const JSONToCSVConvertor = (JSONData, ReportTitle, ShowLabel) => {
  const arrData =
    typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;

  let CSV = '';

  for (let c = 0; c < arrData.length; c++) {
    if (ShowLabel) {
      let row = '';
      for (var index in arrData[c][0]) {
        row += `${index},`;
      }

      row = row.slice(0, -1);
      CSV += `${row}\r\n`;
    }
    for (let i = 0; i < arrData[c].length; i++) {
      let row = '';
      for (var index1 in arrData[c][i]) {
        row += `"${arrData[c][i][index1]}",`;
      }

      row.slice(0, row.length - 1);
      CSV += `${row}\r\n`;
    }

    if (CSV === '') {
      alert('Invalid data');
      return;
    }
    CSV += '\r\n\n';
  }

  const d = new Date();
  const timeStamp = `${d.getFullYear()}_${
    d.getMonth() + 1
  }_${d.getDate()}_${d.getHours()}_${d.getMinutes()}_${d.getSeconds()}`;

  const name = `${timeStamp}_Report.csv`;
  const uri = `data:text/csv;charset=utf-8,${escape(CSV)}`;
  const link = document.createElement('a');
  link.href = uri;

  link.style = 'visibility:hidden';
  link.download = name;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const JSONToCSVConvertorNew = (JSONData, ReportTitle, ShowLabel) => {
  const arrData =
    typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
  let CSV = '';

  _.map(arrData, (c) => {
    if (ShowLabel) {
      let row = '';
      _.map(_.keys(c[0]), (item) => {
        if (!_.isNil(item)) {
          row += `${item},`;
        }
      });

      row = row.slice(0, -1);
      CSV += `${row}\r\n`;
    }

    _.map(c, (i) => {
      let row = '';
      _.map(i, (val) => {
        row += `"${!_.isNil(val) ? val : ''}",`;
      });

      row.slice(0, row.length - 1);
      CSV += `${row}\r\n`;
    });

    if (_.isEmpty(CSV)) {
      alert('Invalid data');
      return;
    }
    CSV += '\r\n\n';
  });

  const d = new Date();
  const timeStamp = `${d.getFullYear()}${
    d.getMonth() + 1
  }${d.getDate()}_${d.getHours()}${d.getMinutes()}${d.getSeconds()}`;

  const name = `${ReportTitle}_${timeStamp}.csv`;
  const uri = `data:text/csv;charset=utf-8,${escape(CSV)}`;
  const link = document.createElement('a');
  link.href = uri;

  link.style = 'visibility:hidden';
  link.download = name;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const JSONToCSVConvertorDirectArray = (
  JSONData,
  ReportTitle,
  ShowLabel
) => {
  const arrData =
    typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
  let CSV = '';

  if (ShowLabel) {
    let row = '';

    _.map(arrData[0], (item, index) => {
      row += `${index},`;
    });

    row = row.slice(0, -1);
    CSV += `${row}\r\n`;
  }

  _.map(arrData, (itemObj) => {
    let row = '';
    _.map(itemObj, (item, index) => {
      row += `"${itemObj[index]}",`;
    });

    row.slice(0, row.length - 1);
    CSV += `${row}\r\n`;
  });

  if (CSV === '') {
    alert('Invalid data');
    return;
  }
  CSV += '\r\n\n';

  const d = new Date();
  const timeStamp = `${d.getFullYear()}_${
    d.getMonth() + 1
  }_${d.getDate()}_${d.getHours()}_${d.getMinutes()}_${d.getSeconds()}`;

  const name = `${timeStamp}_Report.csv`;
  const uri = `data:text/csv;charset=utf-8,${escape(CSV)}`;
  const link = document.createElement('a');
  link.href = uri;

  link.style = 'visibility:hidden';
  link.download = name;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const onFilterApply = (name, filterId) => {
  let obj = [];
  obj = Array.from(
    document.querySelectorAll(`input[name=${name}]:checked`)
  ).map((checkbox) => checkbox.value.toLowerCase());
  return obj.length > 0
    ? obj.includes(filterId.toString().toLowerCase())
    : true;
};

export const checkColor = (Status) => {
  let color;
  if (!Status) {
    return clrHistoric;
  }
  switch (Status.toLowerCase()) {
    case 'live':
      color = clrLive;
      break;
    case 'predicted':
      color = clrPredicted;
      break;
    case 'historic':
      color = clrHistoric;
      break;
    case 'benchmark':
      color = clrBenchmark;
      break;
    default:
      color = clrHistoric;
      break;
  }
  return color;
};
